<template>
  <div>
    <page-title>Notifications</page-title>

    <loading v-if="loading" />

    <div v-else>
      <section-block>
        <template slot="header">
          <filter-bar
            resource="DeviceNotifications"
            :search-query="searchQuery"
            show-search
            show-filter
            :filterOptions="filterOptions"
            filter-url-param="status"
          >
          </filter-bar>
        </template>

        <template slot="actions">
          <base-button
            :primary="true"
            @click="$router.push({ name: 'AdminNotificationCreate' })"
            iconBefore="document-create"
          >
            <span>Create a Notification</span>
          </base-button>
        </template>

        <vuetable
          class="c-data-table"
          :api-mode="false"
          :fields="table.fields"
          :data-manager="dataManager"
          pagination-path
          ref="notifyTable"
          @vuetable:pagination-data="onPaginationData"
          @vuetable:row-clicked="onRowClick"
          :row-class="onRowClass"
        >
          <template slot="title" slot-scope="props">
            <span v-if="props.rowData.title">{{ props.rowData.title }}</span>
            <span v-else>Not set</span>
          </template>
          <template slot="created-by" slot-scope="props">
            {{ props.rowData.modified_username ? props.rowData.modified_username : "N/A" }}
          </template>
          <template slot="date-created" slot-scope="props">
            <base-datetime :date="props.rowData.created_time"></base-datetime>
          </template>
          <template slot="date-sent" slot-scope="props">
            <base-datetime :date="props.rowData.created_time"></base-datetime>
          </template>
          <template slot="actions" slot-scope="props">
            <base-button
              v-if="props.rowData.status == 'pending'"
              @click="load(props.rowData.id)"
              icon-before="edit"
              primary="true"
              >Edit</base-button
            >
            <base-button
              v-else
              @click="load(props.rowData.id)"
              icon-before="search"
              success
              >View</base-button
            >
          </template>
        </vuetable>
        <pagination table-pagination :pagination="pagination">
          <vuetable-pagination
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </pagination>
      </section-block>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Pagination from "@/components/pagination";
import { FormToggle } from "@/components/forms";
export default {
  name: "NotificationAdminIndex",

  components: {
    Pagination,
    VuetablePagination,
    FormToggle,
  },
  data() {
    return {
      loading: true,
      searchQuery: "",
      table: {
        fields: [
          {
            name: "title",
            titleClass: "u-ta-left",
            title: "Notification Title",
            width: "20%",
          },
          {
            name: "created-by",
            titleClass: "u-ta-left",
            title: "Created By",
            width: "20%",
          },
          {
            name: "date-created",
            titleClass: "u-ta-left",
            title: "Date Created",
            width: "10%",
          },
          {
            name: "date-sent",
            titleClass: "u-ta-left",
            title: "Date Sent",
            width: "10%",
          },
          {
            name: "status",
            titleClass: "u-ta-left",
            title: "Status",
            width: "10%",
          },
          {
            name: "actions",
            title: "Actions",
            titleClass: "u-ta-center u-hide-mobile",
            dataClass: "u-ta-center u-hide-mobile",
            width: "20%",
          },
        ],
      },
    };
  },

  computed: {
    ...mapState("DeviceNotifications", ["pagination", "notifications"]),
    filterOptions() {
      return [
        { id: "pending", name: "Pending" },
        { id: "sending", name: "Sending" },
      ];
    },
  },

  watch: {
    notifications(newValue, oldValue) {
      if (newValue && newValue.length !== oldValue.length) {
        this.updateTable();
      }
    },
  },

  mounted() {
    // only do this if there are no query string params
    if (!this.$route.query.status) {
      this.$store
        .dispatch("DeviceNotifications/list", { flat: true })
        .then((resp) => {
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  },
  methods: {
    load(id) {
      this.$router.push({
        name: "AdminNotificationEdit",
        params: { id },
      });
    },
    onRowClass(item, index) {
      return item.status && item.status === "active" ? "bg-active" : "";
    },
    updateTable() {
      this.$refs.notifyTable.refresh();
    },
    dataManager(sortOrder, pagination) {
      const returnObj = {
        ...this.$store.state.DeviceNotifications.pagination,
        data: this.notifications,
      };

      return returnObj;
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onRowClick(row) {
      console.log("🚀 ~ file: Index.vue ~ line 172 ~ onRowClick ~ row", row);
      if (row.event.target.localName === "td") {
        this.$router.push({
          name: "AdminNotificationEdit",
          params: { id: row.data.id },
        });
      }
    },
    onChangePage(page) {
      const vm = this;
      const tableref = vm.$refs.notifyTable;
      let nextPage;
      this.loading = true;

      switch (page) {
        case "next":
          nextPage = ++this.$store.state.DeviceNotifications.pagination
            .current_page;
          break;
        case "prev":
          nextPage = --this.$store.state.DeviceNotifications.pagination
            .current_page;
          break;
        default:
          nextPage = page;
          break;
      }
      this.$store
        .dispatch("DeviceNotifications/list", {
          includeWeb: false,
          page: nextPage,
          flat: true,
        })
        .then((resp) => {
          window.scroll(0, 0);
          tableref.changePage(nextPage);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.bg-active {
  background: lighten($colour-nhs-light-green, 50%);
}
.p-collab-hub {
  &__extra {
    padding-top: 12px;
    border: none !important;
    @media screen and (min-width: 1024px) {
      display: none;

      &.is-shown {
        display: block;
      }
    }
  }
}
</style>
